import type { KbWikiProgress } from "@/lib/kb-api";

/** 与 BrandHub 成熟度条同款的阶段刻度（对齐「收集 → 拆解 → 调取」）。 */
export const KB_PROGRESS_STAGES = ["待起步", "要点萌芽", "基本成形", "可调取"] as const;

export type KbProgressStageIndex = 0 | 1 | 2 | 3;

export function kbProgressStageIndex(score: number): KbProgressStageIndex {
  if (score >= 75) return 3;
  if (score >= 50) return 2;
  if (score >= 25) return 1;
  return 0;
}

export function formatKbLastUpdated(iso: string | null | undefined): string | null {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString("zh-CN", {
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return null;
  }
}

/** 下一关文案：优先提示待维护种子，其次收件箱待处理。 */
export function kbProgressNextHint(progress: KbWikiProgress): string | null {
  if (progress.seed_pending > 0) {
    return `还有 ${progress.seed_pending} 个种子条目待维护`;
  }
  if (progress.inbox_pending > 0) {
    return `知识旅程还有 ${progress.inbox_pending} 条待处理`;
  }
  if (progress.richness_score < 100) {
    return "继续补齐种子要点，提高可调取度";
  }
  return null;
}
